import React from "react";
import { UserRoles } from "../../models/playerModel";
import { MemberRow } from "./TeamMemberRow";
import { TeamHeader } from "./TeamHeader";
import { TeamActions } from "./TeamActions";
import { Divider } from "../catalyst/divider";
import { TeamInvitations } from "./TeamInvitations";
import { XMarkIcon } from "@heroicons/react/24/outline";
import { IconButton } from "../IconButton";
import { useTeamsStore } from "../../store/teamsStore";
import { classNames } from "primereact/utils";
import { useConfirmationDialog } from "../ConfirmDialog";
import { Button } from "../catalyst/button";
import { useSeasonsStore } from "../../store/seasonsStore";

export const EditTeam: React.FC<any> = ({ myTeam, currentUser }) => {
  const { showTeams, setAsCaptain, getTeamDetails } = useTeamsStore();
  const { currentSeason } = useSeasonsStore();
  const { openDialog } = useConfirmationDialog();

  if (
    currentUser.role === UserRoles.admin ||
    currentUser.role === UserRoles.viewer
  ) {
    return null;
  }

  if (currentUser.role === UserRoles.player && !myTeam) {
    return null;
  }

  const setAsCaptainClicked = async (playerId: string) => {
    openDialog({
      title: "Set as Captain",
      message: "Are you sure you want to set this player as captain?",
      onConfirm: async () => {
        await setAsCaptain(playerId);
        getTeamDetails(myTeam.id);
      },
    });
  };

  if (myTeam) {
    return (
      <div>
        <div className="flex justify-end px-2 mt-[-23px]">
          <IconButton onClick={() => showTeams()} Icon={XMarkIcon} text="" />
        </div>
        <div className="flex flex-col items-center">
          <div
            key={myTeam.id}
            className="bg-white dark:bg-gray-800 shadow rounded mb-5 flex flex-col h-full w-full"
          >
            <TeamHeader team={myTeam} />
            <TeamActions team={myTeam} />
            <Divider className="mb-1" />
            {myTeam.members &&
              myTeam.members.map((member: any, index: any) => (
                <div
                  key={member.id}
                  className={classNames(
                    "flex w-full items-center",
                    index % 2 === 0 ? "bg-gray-100 dark:bg-gray-700" : ""
                  )}
                >
                  <MemberRow member={member} className="flex-1" />
                  {member.isPlayer && !member.isCaptain && (
                    <Button
                      outline
                      className="ml-4 text-blue-500 hover:underline"
                      onClick={() => setAsCaptainClicked(member.id)}
                    >
                      Set as Captain
                    </Button>
                  )}
                </div>
              ))}

            {currentSeason &&
              currentSeason.showTeamInvitations &&
              (currentUser.role === UserRoles.nonPlayingTeamOwner ||
                currentUser.role === UserRoles.captain ||
                currentUser.role === UserRoles.playingTeamOwner) && (
                <div className="px-2">
                  <TeamInvitations team={myTeam} />
                </div>
              )}
          </div>
        </div>
      </div>
    );
  }

  return null;
};
